import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChipType } from '../../enum/chip-types';

@Component({
  selector: 'chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss']
})
export class ChipComponent implements OnInit {
  @Input() Label = 'New Chip';
  @Input() Selected = false;
  @Input() Type: ChipType = ChipType.Assist;
  @Input() AssistIcon = '';
  @Output() onClick = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  clicked() {
    switch (this.Type) {
      case ChipType.Assist:
        this.onClick.emit();
        break;
      case ChipType.Filter:
        if (!this.Selected) {
          this.Selected = !this.Selected;
          this.onClick.emit(this.Selected);
        }
        break;
      case ChipType.Input:
        this.onClick.emit();
        break;
      case ChipType.Suggestion:
        this.onClick.emit();
        break;
      default: break;
    }
  }
}
